import { useEffect } from "react";
import { useSnackbar } from "./Snackbar";

const ERROR_NOTIFICATION_DURATION = 8000;

/**
 * Component that listens for Sentry errors and shows a snackbar
 * This component doesn't render anything, it just sets up event listeners
 */
export function SentryErrorHandler() {
  const { showError } = useSnackbar();

  useEffect(() => {
    const handleSentryError = (event: Event) => {
      const customEvent = event as CustomEvent<{
        message: string;
        errorMessage: string;
        eventId: string;
      }>;
      showError(
        `An unexpected error occurred. Our team has been notified. Error: ${customEvent.detail.errorMessage}`,
        ERROR_NOTIFICATION_DURATION
      );
    };

    window.addEventListener("sentry-error", handleSentryError);

    return () => {
      window.removeEventListener("sentry-error", handleSentryError);
    };
  }, [showError]);

  // This component doesn't render anything
  return null;
}
